import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTopRouter = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
  }, []); //eslint-disable-line

  return null;
};

export default withRouter(ScrollToTopRouter);
